/**
 * Arche wrapper for Fias Forge — sub-routing with layout variations
 * (mirrors the Arche Builder):
 * - /:forgeId — full-screen forge workbench (no sidebar)
 * - /         — the forge list, header only
 */
import { Routes, Route } from 'react-router-dom';
import { Header } from '@/components/Header';
import { ForgePage } from './ForgePage';
import { ForgeListPage } from './ForgeListPage';

export function ForgeArchePage() {
  return (
    <Routes>
      <Route path="/:forgeId" element={<ForgePage />} />
      <Route
        path="/*"
        element={
          <div className="flex flex-col h-screen">
            <Header />
            <main className="flex-1 overflow-auto">
              <Routes>
                <Route path="/" element={<ForgeListPage />} />
              </Routes>
            </main>
          </div>
        }
      />
    </Routes>
  );
}
